import { AbstractControl, ValidatorFn } from '@angular/forms'

export function SSNValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {

        let value = control.value;

        if (value) {
            const match = checkSSN(control.value) // nameRe.test(control.value);
            if (!match) {
                return { 'SSN': { value: control.value } };
            }
        }

        return null;
    }
}

function checkSSN(SSN: string): boolean {

    let value: boolean = check_SSN_NO(SSN); //norsk format?

    if (value === false) {
        value = check_SSN_SE(SSN)
    }

    if (value === false) {
        value = check_SSN_DK(SSN);
    }

    return value;
}

function check_SSN_SE(SSN: string): boolean {

    /* YYYYMMDDNNNN */
    if (!SSN || SSN.length !== 12) {
        return false;
    }

    /* kontrollere kun siffer */
    if (!SSN.match(/^[0-9]{12}$/)) {
        return false;
    }

    //kontrollere to første tegn i årstall
    if (SSN.substring(0, 2) !== '19' && SSN.substring(0, 2) !== '20') {
        return false;
    }

    //kontrollere måned mellom 1 og 12
    let month = +SSN.substring(4, 6);
    if (!(month > 0 && month < 13)) {
        return false;
    }

    //kontrollere dag mellom 1 og 31
    let day = +SSN.substring(6, 8);
    if (!(day > 0 && day < 32)) {
        return false;
    }

    // regn ut kontrollsiffer
    const luhnCheck = (num:string) => {
        let arr = (num + '')
            .split('')
            .map(x => parseInt(x));
        let lastDigit = arr.splice((arr.length - 1), 1)[0];

        // let sum = arr.reduce(
        //     (acc, val, i) => (i % 2 !== 0 ? acc + val : acc + ((val * 2) % 9) || 9), 0
        // );

        let sum = arr.reduce(
            (acc, val, i) => {
                var value = i % 2 !== 0 ? val : (val * 2);
                value = ((value - 1) % 9) + 1;
                return acc + value;
            }, 0
            // (((i % 2 !== 0 ? acc + val : acc + (val * 2)) - 1) % 9 + 1), 0
        );

        sum += lastDigit;
        return sum % 10 === 0;
    };

    return luhnCheck(SSN.substring(2));

}

function check_SSN_DK(SSN: string): boolean {

    /* DDMMYYNNNN */
    if (!SSN || SSN.length !== 10) {
        return false;
    }

    /* kontrollere kun siffer */
    if (!SSN.match(/^[0-9]{10}$/)) {
        return false;
    }

    //kontrollere dag mellom 1 og 31
    let day = +SSN.substring(0, 2);
    if (!(day > 0 && day < 32)) {
        return false;
    }

    //kontrollere måned mellom 1 og 12
    let month = +SSN.substring(2, 4);
    if (!(month > 0 && month < 13)) {
        return false;
    }

    //kontrollere to første tegn i årstall
    // if (SSN.substring(4, 6) !== '19' && SSN.substring(4, 6) !== '20') {
    //     return false;
    // }

    var rest: string = SSN.substring(4);
    if (!rest.match(/^[0-9]{6}$/)) {
        return false;
    }

    return true;
}

function check_SSN_NO(SSN: string): boolean {
    if (!SSN || SSN.length !== 11) {
        return false;
    }

    var _sum = function (birthNumber: string, factors: number[]) {
        var sum = 0;
        for (var i = 0, l = factors.length; i < l; ++i) {
            sum += parseInt(birthNumber.charAt(i), 10) * factors[i];
        }
        return sum;
    };

    var checksum1 = 11 - (_sum(SSN, [3, 7, 6, 1, 8, 9, 4, 5, 2]) % 11);
    if (checksum1 === 11) checksum1 = 0;
    var checksum2 = 11 - (_sum(SSN, [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]) % 11);
    if (checksum2 === 11) checksum2 = 0;
    return checksum1 === parseInt(SSN.charAt(9), 10)
        && checksum2 === parseInt(SSN.charAt(10), 10);
}